import { useRef } from "react"
import ImgError from "assets/images/img-error.png"

const Image = ({ src }) => {
    const imgRef = useRef()
    return (
        <img src={src ?? ""} alt="photos" ref={imgRef}
            onError={() => imgRef.current.src = ImgError}
        />
    )
}

export default Image